import React from 'react';
import moment from 'moment';

export type DateRange = {
  from: moment.Moment | undefined;
  to: moment.Moment | undefined;
};

export type QuickSelectKey =
  | 'today'
  | 'yesterday'
  | 'last7days'
  | 'last14days'
  | 'last30days'
  | 'thisWeek'
  | 'monthToYesterday'
  | 'lastMonth';

export type QuickSelectOption = {
  labelId: string;
  getValue: () => DateRange;
};

export type RBHDateRangePickerProps = {
  label: React.ReactNode;
  disabled?: boolean;
  minDate?: moment.Moment;
  maxDate?: moment.Moment;
  value?: DateRange;
  onChange: (range: DateRange) => void;
  maxDateRange?: number;
  disabledDates?: moment.Moment[];
  quickSelect?: (QuickSelectKey | QuickSelectOption)[];
  style?: React.CSSProperties;
};

export const getDayLabels = (locale: string): string[] => moment.localeData(locale).weekdaysMin();

export const MSG = {
  quickSelectTitle: 'main.shared.drp-v2.quick-select-title',
  today: 'main.shared.drp-v2.today',
  yesterday: 'main.shared.drp-v2.yesterday',
  last7days: 'main.shared.drp-v2.last-7-days',
  last14days: 'main.shared.drp-v2.last-14-days',
  last30days: 'main.shared.drp-v2.last-30-days',
  thisWeek: 'main.shared.drp-v2.this-week',
  monthToYesterday: 'main.shared.drp-v2.this-month',
  lastMonth: 'main.shared.drp-v2.last-month',
  startDate: 'main.shared.drp-v2.start-date',
  endDate: 'main.shared.drp-v2.end-date',
  cancel: 'main.shared.drp-v2.cancel',
  apply: 'main.shared.drp-v2.apply',
};
